import { performRequest } from "../performRequest"


export const getExpensesApi = (params) => {
    return performRequest("get", "/api/ess/expense/",params)
}



export const postExpensesApi = (params) => {
    return performRequest("post", "/api/ess/expense/",params)
}




export const getExpenseApi = (id,params) => {
    return performRequest("get", `/api/ess/expense/${id}/`,params)
}

export const deleteExpenseApi = (id) => {
    return performRequest("delete", `/api/ess/expense/${id}/`)
}

export const getExpenseType = (id,params) => {
    let p = {
        ...params,
        status:true,
        sort_by:"name",
        sort_type:"desc"
    }
    return performRequest("get", `api/ess/expense-type/`,p)
}


export const updateExpensesApi = (id, params) => {
    return performRequest("put", `/api/ess/expense/${id}/`,params)
}


export const statusChangeExpenseApi = (params,id) => {
    return performRequest("patch", `/api/ess/expense/${id}/`,params)
}


export const exportExpenseApi = (expenseId, companyId) => {
    return performRequest(
        "get",
        `/api/ess/expense-export/${expenseId}/?company=${companyId}`,
        {}, // no params
        true, // login
        "blob" // responseType
    );
};